import axios from 'axios';

export default {
	namespaced: true,

	state: {
		entryId: 0,
		baseProducts: [],
		largeLetterStyle: null,
		smallLetterStyle: null,
		customizationStyle: {},
		userText: '',
		csrfToken: '',
		inputError: false,
		selectedBaseProduct: null,
		selectedVariant: null,
		allProducts: [],
		allCustomizationStyles: [],
		loadingBase: true,
		loadingLargeLetters: true,
		loadingSmallLetters: true,
		bundleLetterProducts: []
	},

	mutations: {
		setEntryId(state, entryId) {
			state.entryId = entryId;
		},
		setBaseProducts(state, baseProducts) {
			state.baseProducts = baseProducts;
		},
		setLargeLetterStyle(state, largeLetterStyle) {
			state.largeLetterStyle = largeLetterStyle;
		},
		setSmallLetterStyle(state, smallLetterStyle) {
			state.smallLetterStyle = smallLetterStyle;
		},
		setUserText(state, userText) {
			state.userText = userText;
		},
		setCustomizationStyle(state, customizationStyle) {
			state.customizationStyle = customizationStyle;
		},
		setCsrfToken(state, token){
			state.csrfToken = token;
		},
		setInputError(state, inputError) {
			state.inputError = inputError;
		},
		setSelectedBaseProduct(state, baseProduct) {
			state.selectedBaseProduct = baseProduct;
		},
		setSelectedVariant(state, variant) {
			state.selectedVariant = variant;
		},
		setAllProducts(state, allProducts) {
			state.allProducts = allProducts;
		},
		setAllCustomizationStyles(state, allCustomizationStyles) {
			state.allCustomizationStyles = allCustomizationStyles;
		},
		setLoadingBase(state, loading) {
			state.loadingBase = loading;
		},
		setLoadingLargeLetters(state, loading) {
			state.loadingLargeLetters = loading;
		},
		setLoadingSmallLetters(state, loading) {
			state.loadingSmallLetters = loading;
		},
		setBundleLetterProducts(state, letterProducts) {
			state.bundleLetterProducts = letterProducts;
		},
	},

	getters: {
		getEntryId(state) {
			return state.entryId;
		},
		getBaseProducts(state) {
			return state.baseProducts;
		},
		getLargeLetterStyle(state) {
			return state.largeLetterStyle;
		},
		getSmallLetterStyle(state) {
			return state.smallLetterStyle;
		},
		getCustomizationStyle(state) {
			return state.customizationStyle;
		},
		getUserText(state) {
			return state.userText;
		},
		getUserTextAsArray(state) {
			return state.userText.split('');
		},
		getCsrfToken(state) {
			return state.csrfToken;
		},
		getInputError(state) {
			return state.inputError;
		},
		getSelectedBaseProduct(state) {
			return state.selectedBaseProduct;
		},
		getSelectedVariant(state) {
			return state.selectedVariant;
		},
		getAllProducts(state) {
			return state.allProducts;
		},
		getAllCustomizationStyles(state) {
			return state.allCustomizationStyles;
		},
		getLoadingBase(state) {
			return state.loadingBase;
		},
		getLoadingLargeLetters(state) {
			return state.loadingLargeLetters;
		},
		getLoadingSmallLetters(state) {
			return state.loadingSmallLetters;
		},
		getBundledProducts(state) {
			// Bundles/Merges both base product and letter products into one array
			state.selectedVariant.qty = 1;
			state.selectedVariant.purchasableId = state.selectedVariant.id;
			state.selectedVariant.price = state.selectedVariant.price > state.selectedVariant.salePrice ? 
				state.selectedVariant.salePrice : state.selectedVariant.price;
			return [...[state.selectedVariant], ...state.bundleLetterProducts];
		},
	},

	actions: {
		// Initializes the product by making calls to the endpoints to get our data
		initProduct({ commit, dispatch, getters }, { baseIds, baseType, customizationStyles, largeLetterId, smallLetterId }) {
			// Fetch the base product
			axios.get(`/store/products/customizable/base?id=${baseIds}&type=${baseType}`).then((response) => {
				commit('setBaseProducts', response.data);
				commit('setAllCustomizationStyles', customizationStyles);
				dispatch('selectBaseProduct', 0);
				dispatch('selectBaseVariant', 0);
				dispatch('selectCustomizationStyle', getters.getAllCustomizationStyles[0]);
				commit('setLoadingBase', false);
			});

			// Fetch the large letters
			axios.get(`/store/products/letters/index?id=${largeLetterId}`)
				.then((response) => {
					commit('setLargeLetterStyle', response.data[0])
					commit('setLoadingLargeLetters', false);
				});

			// Fetch the small letters
			axios.get(`/store/products/letters/index?id=${smallLetterId}`)
				.then((response) => {
					commit('setSmallLetterStyle', response.data[0])
					commit('setLoadingSmallLetters', false);
				});
		},

		// Selects the base product
		selectBaseProduct({ commit, state }, index) {
			// Filter out disabled variants
			const enabledVariants = state.baseProducts[index].variants.filter(variant => variant.enabled);
			state.baseProducts[index].variants = enabledVariants;
			commit('setSelectedBaseProduct', state.baseProducts[index]);
		},

		// Selects the base products variant
		selectBaseVariant({ commit, state }, index) {
			commit(
				'setSelectedVariant',
				state.selectedBaseProduct.variants[index]
			);
		},

		// Selects the customization style (and clears out the textArray)
		selectCustomizationStyle({ commit }, customizationStyle) {
			commit('setCustomizationStyle', customizationStyle);
			commit('setUserText', '');
		}
	}
};
